export function reloadPage() {
  window.location.reload();
}

export function redirect(url) {
  window.location.assign(url);
}